import * as React from "react";
import LoginLoaderContainer from "../../containers/login/LoginLoaderContainer";
import LoginPage from "../LoginPage";
import SignupPage from "../SignupPage";
import SignupCompleteContainer from "../../containers/signup/SignupCompleteContainer";
import LogoutContainer from "../../containers/login/LogoutContainer";
import TokenPage from "../TokenPage";
import FixturesPage from "../FixturesPage";
import ChangePasswordPage from "../ChangePasswordPage";
import { Authenticator, ILogin, PrivateRoute } from "../../components/security";
import { BrowserRouter, Link } from "react-router-dom";
import { Logo } from "../../controls/Logo";
import { dashboardTheme } from "../../styles/DashboardTheme";

import {
    Redirect,
    Route,
    Switch,
    withRouter
    } from "react-router";
import { Unsubscribable } from "rxjs";
import "./layout.css";
import { MuiThemeProvider } from "@material-ui/core";

function RedirectToToken(props) { return <Redirect {...props} to="/token" />; }
function RedirectToLogin(props) { return <Redirect {...props} to="/login" />; }
function RedirectToChangePW(props) { return <Redirect {...props} to="/changepw" />; }
function RedirectToRoot(props) { return <Redirect {...props} to="/" />; }

interface IState
{
    authenticatorSubscription?: Unsubscribable;
    login?: ILogin;
}

class App extends React.Component<any, IState>
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    public render()
    {
        let tokenActive = "";
        let fixturesActive = "";
        let changePWActive = "";
        switch (this.props.location.pathname) {
            case "/fixtures":
                fixturesActive = "active";
                break;
            case "/token":
                tokenActive = "active";
                break;
            case "/changepw":
                changePWActive = "active";
                break;
        }

        return (
            <MuiThemeProvider theme={dashboardTheme}>
                <div className="pageLayout">
                    <link href="https://fonts.googleapis.com/css?family=Montserrat|Roboto" rel="stylesheet" />
                    <header className="logo">
                        <Logo />
                    </header>
                    {/* {Authenticator.isLoggedIn ? (
                        <section key="logout-header" className="logout-header">
                            Welcome {Authenticator.username} | <LogoutContainer />
                        </section>
                    ) : null} */}
                    <main className="main">
                        {Authenticator.isLoggedIn ? (
                            <aside key="sidebar" className="nav-sidebar">
                                <Link to="/token" className={"sidebar-element " + tokenActive}>Token</Link>
                                <Link to="/fixtures" className={"sidebar-element " + fixturesActive}>Fixtures</Link>
                                <Link to="/changepw" className={"sidebar-element " + changePWActive}>Change Password</Link>
                                {/*<Link to="/account" className="sidebar-element">Account</Link>*/}
                                {/*<Link to="/token" className="sidebar-element">Billing</Link>*/}
                                {/*<Link to="/subscription" className="sidebar-element">Subscription</Link>*/}
                                {/*<SubscriptionLink to="/subscription" className="sidebar-element">Subscription</SubscriptionLink>*/}
                                <LogoutContainer />
                            </aside>
                        ) : null}
                        <Switch>
                            <PrivateRoute path="/token" component={TokenPage} unauthenticatedPath="/login" />
                            <PrivateRoute path="/fixtures" component={FixturesPage} unauthenticatedPath="/login" />
                            <PrivateRoute path="/changepw" component={ChangePasswordPage} unauthenticatedPath="/login" />
                            {/*<PrivateRoute path="/subscription" component={SubscriptionPage} unauthenticatedPath="/login" />*/}
                            {/* <SubscriptionRoute path="/subscription" component={SubscriptionPage} unauthenticatedPath="/login" missingCapabilityPath="/" /> */}
                            <Route path="/login" component={LoginPage} />
                            {/*<Route path="/signup" component={SignupPage} /> */}
                            {/*<Route path="/signup-complete" component={SignupCompleteContainer} /> */}
                            <Route component={RedirectToToken} />
                        </Switch>
                    </main>
                    
                </div>
            </MuiThemeProvider>
        );
    }

    public componentWillMount()
    {
        this.setState({
            authenticatorSubscription: Authenticator.subscribe(login => this.setState({ login }))
        });
    }

    public componentWillUnmount()
    {
        const authenticatorSubscription = this.state.authenticatorSubscription;
        if (authenticatorSubscription)
        {
            authenticatorSubscription.unsubscribe();
        }
    }
}

export default withRouter(App);
